import { render } from "./ChannelUnban.vue?vue&type=template&id=127022b5"
import script from "./ChannelUnban.vue?vue&type=script&lang=ts"
export * from "./ChannelUnban.vue?vue&type=script&lang=ts"
script.render = render

export default script